import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ControlService implements OnDestroy {
  public formEvent$ = new Subject();

  constructor() {}

  public ngOnDestroy(): void {
    this.formEvent$.next(true);

    this.formEvent$.complete();
  }
}
